import styled from "styled-components";
import { Color } from "../../../utils/styleDesignSystem";

import useVariation from "../../../hooks/useVariation";
// NOTE: This component is intentionally text-only (no images) per design.

type Promotion = {
  slug: string;
};

type WelcomeOfferDetailsProps = {
  promotion: Promotion;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;

const Section = styled.div`
  padding: var(--spacing-1_5) 0;
  border-bottom: 0.5px solid var(--cool-60, #DBE2E6);

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: var(--spacing-1);
  }
`;

const Headline = styled.h4`
  color: ${Color.indigoBlue};
  margin: 0 0 var(--spacing-0_5) 0;
`;

const Body = styled.p`
  color: ${Color.indigoBlue};
  margin: 0;
`;

const Disclaimer = styled.div`
  padding-top: var(--spacing-1);
  padding-left: 16px;
  padding-right: 16px;
  margin-left: -16px;
  margin-right: -16px;
  border-top: 0.5px solid var(--cool-60, #DBE2E6);

  p {
    font: var(--font-circular);
    font-weight: 300;
    color: ${Color.indigoBlue60};
    margin: 0;
    font-size: var(--spacing-0_75, 12px);
  }
`;

const WelcomeOfferDetails = ({ promotion }: WelcomeOfferDetailsProps) => {
  const showGutHealthMonthDetails = useVariation("gut-health-month-details", false);

  // Both `welcome` and `welcome-offer-bundle` should show the same evergreen details.
  // (Guard retained for readability / futureproofing.)
  if (!["welcome", "welcome-offer-bundle", "bundle-promotion"].includes(promotion?.slug)) return null;

  return (
    <Container data-testid="welcome-offer-details">
      <Section>
        <Headline className="typography-label1">{`Welcome Offer`}</Headline>
        <Body className="typography-body2">
          {`Save 20% off your first order of eligible, single items. Bundles are priced as marked with discounts up to 30% off your first order.`}
        </Body>
      </Section>

      {showGutHealthMonthDetails && (
        <Section>
          <Headline className="typography-label1">
            {`Gut Health Month`}
          </Headline>

          <Body className="typography-body2">
            <i>{`While Supplies Last`}</i>
            <br />
            {`Get a FP Movement Quilted Micro Pouch FREE on orders of Synbiotic+ or Natalbiotic™. Pouch color will be chosen at random.`}
          </Body>
        </Section>
      )}

      <Disclaimer>
        <p className="typography-caption">
          {`Offer is only available for new customers and cannot be combined with any other promotions or discounts, or applied to prior purchases, and can only be redeemed once per customer. Discount limited to a maximum of two units per unique product.  Gifts are limited to one per customer and are offered only while supplies last.`}
        </p>
      </Disclaimer>
    </Container>
  );
};

export default WelcomeOfferDetails;

